import React from "react";
import computer from "../assets/computer.png";
import myAvatar from "../assets/myAvatar.png";
import myAvatarEyesClosed from "../assets/myAvatarEyesClosed.png";

const About = (props) => {
  return (
    <div className="about mt-5">
      <div className="row justify-content-center">
        <div className="col-10">
          <div className="fs-1 myfont">
            {" "}
            Web Dev by day -{" "}
            <span style={{ color: "orange" }}>"Coder-For-Hire"</span> by night
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 mt-3">
          <div className="col-lg-7">
            <div className="myfont_p">
              I am a full-stack web developer working as a Web Development
              Specialist in sunny Fort Lauderdale, Florida.
            </div>
            <div className="col-3 float-start m-3 ms-md-3" onClick={props.switchTheme}>
              <img
                className="img-fluid bg-transparent border-0"
                style={{opacity:"90%"}}
                src={props.theme !== "light" ? myAvatar : myAvatarEyesClosed}
                alt="Pawel Jaskolski avatar"
              />
              <figcaption className="text-center fst-italic">
                {props.theme !== "light" ? (
                  <small>"I like the dark mode, light attracts bugs!"</small>
                ) : (
                  <small>"It's too bright for me...you go ahead."</small>
                )}
              </figcaption>
            </div>
            <br />
            <div className="myfont_p">
              I am an avid problem solver. I believe that quality is what makes
              me an excellent web developer.
            </div>
            <br />
            <div className="myfont_p">
              I am a hardworking individual who brings passion and insight into
              everything I do.
            </div>
            <br />
            <div className="myfont_p">
              In my free time, I enjoy reading self-improvement literature,
              while expanding my coding “powers” one component problem at a
              time. I also enjoy going to different restaurants and trying to
              find the best fried-calamari with my favorite human!{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-10">
          <div className="fs-1 myfont">
            {" "}
            What's in it <span style={{ color: "orange" }}>for you</span>?
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 mt-3">
          <div className="col-lg-7">
            <div className="myfont_p">
              Building, updating, and maintaining a good website is not an easy
              task. Developing new components and features that you have in your
              mind is not as easy as it sounds. Many features that you may want
              are not Plug and Play, and that is where I come in.
            </div>
            <br />
            <div className="myfont_p">
              I come across many ambitious entrepreneurs who oftentimes use a
              CMS such as Squarespace, WordPress, or Wix to quickly get a
              website for their business…and I get it, it is convenient and easy
              to use.
            </div>
            <div className="col-4 float-end m-3 ms-md-3">
              <img
                className="img-thumbnail img-fluid bg-transparent border-0"
                src={computer}
                alt="Keyboard and lightbulb idea logo"
              />
            </div>
            <br />
            <div className="myfont_p">
              However, having a website and having a good website are two
              different things. I am not saying that the design is bad because
              it is never bad…it only needs a bit of code TLC.
            </div>
            <br />
            <div className="myfont_p">
              I work with small businesses, side-business owners, and small
              startups to bring their CMS-based websites to their glory. I
              remedy and provide a helping hand in website needs and wants, such
              as new features, design adjustments, mobile-friendliness, and
              whatever else they may need.
            </div>
            <br />
            <div className="myfont_p">
              An important fact is that new businesses are short on funds and
              here is some good news. If you are willing to share the success of
              your business down the road, I will work for I-O-Us…if you have a
              “cause worthy” business, I do work Pro-Bono.{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
